import * as React from 'react';

import {RemoveButton} from '../button/remove-button/remove-button';

import styles from './two-row-item.module.css';

export type Props = {
    topRow: React.ReactNode;
    bottomRow: React.ReactNode;
    onRemove?: () => void;
};

export function TwoRowItem({topRow, bottomRow, onRemove}: Props) {
    return (
        <div className={styles.row}>
            <div className={styles.item}>
                <div className={styles['top-row']}>{topRow}</div>
                <div className={styles['bottom-row']}>{bottomRow}</div>
            </div>
            <div className={styles.buttons}>
                {onRemove ? <RemoveButton size={12} onClick={onRemove} /> : null}
            </div>
        </div>
    );
}
